import * as forge from 'node-forge'

export function encryptToBytes(body: string): ArrayBuffer {
  return base64ToArrayBuffer(encrypt(body))
}

function encrypt(body: string): string {
  const key = 'asdfghjkmnbvcfg5'
  const iv = 'pixltrendmull123'

  const bodyBytes = stringToBytes(body)
  const bodyBase64 = base64ToArrayBuffer(btoa(unescape(encodeURIComponent(String.fromCharCode(...bodyBytes)))))

  const cipher = forge.cipher.createCipher('AES-CBC', key)
  cipher.start({ iv })
  cipher.update(forge.util.createBuffer(bodyBase64))
  cipher.finish()

  return cipher.output.getBytes()
}

function stringToBytes(string: string): Array<number> {
  let bytes: Array<any> = []

  for (let i = 0; i < string.length; ++i) {
    const code = string.charCodeAt(i)

    bytes = bytes.concat([code])
  }

  return bytes
}

function base64ToArrayBuffer(base64: string) {
  const len = base64.length
  const bytes = new Uint8Array(len)

  for (let i = 0; i < len; i++) {
    bytes[i] = base64.charCodeAt(i)
  }

  return bytes.buffer
}
